export enum ErrorCodes {
  // Todo: implement all error codes
  noDataAvailable = 1,
  startTimeInFuture = 2,
  noOrderRegistered = 3,
  noStartTimeSet = 4,
  noEndTimeSet = 5,
  dataUndefined = 6,
  loading = 7,
  noDate = 8,
  invalidEventId = 9,
  serverError = 10,
  negativeValues = 11,
}
